export default {"src":"/_next/static/media/btn-fb.8309d655.svg","height":44,"width":45,"blurWidth":0,"blurHeight":0};